import styles from "./TermsAndPoliciesContent.module.css";

export default function TermsAndPoliciesContent({
  title,
  content,
  highlightText,
  link,
}) {
  return (
    <div className={styles.section}>
      {" "}
      <div className={styles.title}>{title}</div>
      <div className={styles.line}></div>
      {content && (
        <div className={styles.content}>
          {content.split("\n").map((line, index) => {
            if (line.startsWith("##")) {
              return (
                <p key={index} className={styles.subHeadings}>
                  {line.replace("##", "")}
                </p>
              );
            } else if (line.startsWith("**")) {
              return (
                <p key={index} className={styles.listItem}>
                  <span className={styles.listMarker}> • </span>
                  {line.substring(2).startsWith("##")
                    ? (() => {
                        const text = line.replace("**##", "");
                        const [beforeColon, afterColon] = text.split(/:(.+)/);
                        return (
                          <>
                            <span className={styles.subHeadings}>
                              {beforeColon.trim()}
                            </span>
                            : {afterColon?.trim()}
                          </>
                        );
                      })()
                    : line.replace("**", "")}
                </p>
              );
            } else {
              return <p key={index}>{line}</p>;
            }
          })}
        </div>
      )}
    </div>
  );
}
